<template>
    <div class="saved-survey-container">
        <p class="mb-2">
            Encuesta guardada con éxito
        </p>
        <v-btn
            color="primary"
            @click="newSurvey"
            prepend-icon="mdi-plus"
        >
            Agregar nueva encuesta
        </v-btn>
    </div>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router';

const router = useRouter()

function newSurvey() {
    router.push({ name: 'home' })
}
</script>

<style lang="scss" scoped>
.saved-survey-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
}
</style>